/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

const CallbackPage = lazy(() =>
  import("@krea/shared/features/callback-page").then((m) => ({
    default: m.CallbackPage,
  })),
);
const CookieConsent = lazy(() =>
  import("@krea/customer-features/shared-components/cookie-consent").then(
    (m) => ({ default: m.default }),
  ),
);
const CustomerWebApp = lazy(() =>
  import("./App").then((m) => ({ default: m.CustomerWebApp })),
);

export const router = createBrowserRouter([
  {
    path: "callback-page/:callbackPageId",
    element: <CallbackPage />, // For oauth callback handling
  },
  {
    path: "*",
    element: (
      <div className="flex h-full">
        <CustomerWebApp />
        <CookieConsent />
      </div>
    ),
  },
]);
